var AdjustmentLevel = /** @class */ (function () {
    function AdjustmentLevel(obj, id) {
        if (id) {
            this.id = id;
        }
        this.from_price = obj.from_price;
        this.to_price = obj.to_price;
        this.percent_adjustment = obj.percent_adjustment;
    }
    Object.defineProperty(AdjustmentLevel.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdjustmentLevel.prototype, "FromPrice", {
        get: function () {
            return this.from_price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdjustmentLevel.prototype, "ToPrice", {
        get: function () {
            return this.to_price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdjustmentLevel.prototype, "PercentAdjustment", {
        get: function () {
            return this.percent_adjustment;
        },
        enumerable: false,
        configurable: true
    });
    return AdjustmentLevel;
}());
export { AdjustmentLevel };
export function createAdjustmentLevel(obj, id) {
    return new AdjustmentLevel(obj, id);
}
export function createVolumePromotionLevel(obj, id) {
    return new AdjustmentLevel(obj, id);
}
export function createAdjustmentLevels(rawAdjustmentLevels) {
    var adjustmentLevels = [];
    var rawAdjustmentLevelsData = rawAdjustmentLevels.data;
    for (var _i = 0, rawAdjustmentLevelsData_1 = rawAdjustmentLevelsData; _i < rawAdjustmentLevelsData_1.length; _i++) {
        var rawAdjustmentLevel = rawAdjustmentLevelsData_1[_i];
        var adjustmentLevel = createAdjustmentLevel(rawAdjustmentLevel.attributes, rawAdjustmentLevel.id);
        adjustmentLevels.push(adjustmentLevel);
    }
    return adjustmentLevels;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/adjustmentLevel/adjustmentLevel.ts
// module id = 111
// module chunks = 0